import get from 'lodash.get';

const getFontPairs = (state) => get(state, 'ws.template.meta.customization.fontPairs', []);

export default getFontPairs;
